const becomeSellerNp = {
  breadcrumbs: {
    home: 'होम',
    becomeSeller: 'विक्रेता बन्नुहोस्'
  },
  hero: {
    title: 'विक्रेता बन्नुहोस्',
    subtitle: 'ग्रामीण बजारसँग आफ्नो व्यवसाय बढाउनुहोस् र करोडौं ग्राहकहरूसमक्ष पुग्नुहोस्',
    cta: 'अहिले नै सुरू गर्नुहोस्'
  },
  stats: [
    { value: '50,000+', label: 'सक्रिय विक्रेता' },
    { value: '98%', label: 'समयमै भुक्तानी' },
    { value: '300%', label: 'औसत बिक्री वृद्धि' },
    { value: '4.8/5', label: 'विक्रेता सन्तुष्टि' }
  ],
  benefits: {
    title: 'विक्रेता हुने फाइदा',
    items: [
      { title: 'बिक्री बढाउनुहोस्', description: 'हाम्रा १M+ ग्राहकहरूसम्म आफ्नो वस्तु पुर्‍याउनुहोस्' },
      { title: 'अझ बढी कमाइ', description: 'प्रतिस्पर्धी कमिसन दर र छिटो भुक्तानी' },
      { title: '२४/७ सपोर्ट', description: 'हाम्रो समर्पित सेलर सपोर्ट टोली सधैं तपाईं साथमा' },
      { title: 'सुरक्षित कारोबार', description: 'पूर्ण सुरक्षित र पारदर्शी भुक्तानी प्रणाली' },
      { title: 'छिटो सेटअप', description: '२४ घण्टाभित्र तपाईंको पसल सुरु गर्नुहोस्' },
      { title: 'बिक्री विश्लेषण', description: 'विस्तृत रिपोर्ट र बिक्री ट्र्याकिङ' }
    ]
  },
  steps: {
    title: 'कसरी सुरु गर्ने',
    stepNumbers: ['१', '२', '३'],
    items: [
      { title: 'दर्ता', description: 'व्यक्तिगत र व्यवसायिक विवरणसहित दर्ता गर्नुहोस्' },
      { title: 'प्रमाणीकरण', description: 'हाम्रो टोलीले २४ घण्टाभित्र प्रमाणीकरण गर्छ' },
      { title: 'बिक्री सुरु', description: 'वस्तु अपलोड गर्नुहोस् र बिक्री सुरु गर्नुहोस्' }
    ]
  },
  cta: {
    title: 'आजै आफ्नो डिजिटल व्यवसाय सुरु गर्नुहोस्',
    subtitle: 'ग्रामीण बजारसँग जोडिनुहोस् र आफ्नो व्यवसायलाई नयाँ उचाइमा पुर्‍याउनुहोस्',
    button: 'विक्रेताको रूपमा जोडिनुहोस्'
  },
  transformDreams: {
    title: "ग्रामीण बजारसँग आफ्ना सपना पूरा गर्नुहोस्",
    content: [
        "कल्पना गर्नुहोस्, तपाईंको व्यापार कसरी फुल्दैछ – केवल चिनिएका अनुहारहरूसँग मात्र होइन, बरु प्रत्येक गाउँका नयाँ ग्राहकहरूसँग पनि, जसले तपाईंलाई पहिलो पटक पत्ता लगाइरहेका छन्। ग्रामीण बजारमा, तपाईंको उत्पादन ती मानिसहरूको दैनिकीको अभिन्न हिस्सा बन्छ, जसले पहिले कहिल्यै कुनै बजारमा किनमेल गरेका थिएनन्।",
        "हाम्रो शक्तिशाली बजार प्रवर्द्धन गहिरो गाउँसमुदायसम्म पुग्छ, छिमेकी र साथीहरूलाई एकत्रित गर्छ, जसले तपाईं जस्तै स्थानीय विक्रेताहरूलाई सहयोग गर्न चाहन्छन्। हाम्रो पछिल्लो सर्वेक्षणले एक अद्भुत तथ्य देखायो: हाम्रा करिब 30% खरिदकर्ताहरू पहिलो पटक बजारका ग्राहक बनेका छन्, जो तपाइँबाट किनमेल गर्न तयार र उत्सुक छन्।",
        "यो एउटा यस्तो मौका हो जुन तपाईंले पहिले कहिल्यै पाउनु भएको थिएन – जसले तपाईंले कहिल्यै नपुगेका मानिसहरूसम्म पुग्न, उनीहरूलाई तपाईंको कथामा स्वागत गर्न, र तपाईंको बिक्री 50% देखि 100% वा अझ बढीले बढाउन सक्नुहुन्छ। ग्रामीण बजारमा सामेल हुनुहोस् – यो केवल एउटा प्लेटफर्म मात्र होइन, बरु एउटा आन्दोलन हो।",
        "आउनुहोस्, हामीसँग मिलेर आशा, अवसर र समृद्धि तपाइँको परिवार, तपाईंको गाउँ र तपाईंको सपना सम्म ल्याऔं। ग्राहकहरू पर्खिरहेका छन् – अब तपाईंको चम्कने समय हो।"
    ]
  }

};

export default becomeSellerNp;


